<template>
  <v-row>

    <v-col cols="12" class="mt-4" v-if="!$vuetify.breakpoint.xs">
      <v-tabs
        fixed-tabs
        v-model="tabs"
        class="tab-gallery"
        :background-color="color_tab"
        slider-size="8"
        :slider-color="(project_gallery_mode)?'white':'black'"
        height="70px"
      >
        <v-tab @click="handleTabChange(0)" :style="{ color: (project_gallery_mode)?'white':'black' }">
          <v-icon class="mr-6" :color="(project_gallery_mode)?'white':'black'">mdi-lightbulb-on-outline</v-icon>
          Ideas Proyecto
        </v-tab>

        <v-tab @click="handleTabChange(1)" :style="{ color: (project_gallery_mode)?'white':'black' }">
          <v-icon :color="(project_gallery_mode)?'white':'black'">mdi-town-hall</v-icon>
          Ideas Proyecto(escuelas secundarias)
        </v-tab>
        
        <v-tab @click="handleTabChange(2)" :style="{ color: (project_gallery_mode)?'white':'black' }">
          <v-icon class="mr-6" :color="(project_gallery_mode)?'white':'black'">mdi-account-cash</v-icon>
          Modelos de Negocio
        </v-tab>
      </v-tabs>
    </v-col>

    <v-col cols="12" class="mt-4" v-if="$vuetify.breakpoint.xs">
      <v-tabs
        fixed-tabs
        v-model="tabs"
        class="tab-gallery"
        slider-size="8"
        :slider-color="(project_gallery_mode)?'white':'black'"
        :background-color="color_tab"
        dark
        height="70px"
      >
        <v-tab @click="handleTabChange(0)">
          <v-icon class="mr-6" :color="(project_gallery_mode)?'white':'black'">mdi-lightbulb-on-outline</v-icon>
        </v-tab>
        <v-tab @click="handleTabChange(1)">
          <v-icon :color="(project_gallery_mode)?'white':'black'">mdi-town-hall</v-icon>
        </v-tab>
        <v-tab @click="handleTabChange(2)">
          <v-icon class="mr-6" :color="(project_gallery_mode)?'white':'black'">mdi-account-cash</v-icon>
        </v-tab>
      </v-tabs>

      <h4 v-if="type_postulation===0" class="pt-4" align="center">
        Ideas Proyectos
      </h4>
      <h4 v-if="type_postulation===1" class="pt-4" align="center">
        Ideas Proyectos (escuelas secundarias)
      </h4>
      <h4 v-if="type_postulation===2" class="pt-4" align="center">
        Modelos de Negocio
      </h4>
    </v-col>

    <v-col cols="12">
      <v-text-field
        v-model="find"
        label="Buscar"
        outlined
        clearable
        background-color="white"
      ></v-text-field>
    </v-col>

    <v-col 
      cols="12" 
      xl="3" 
      md="3" 
      sm="12" 
      align="center"
      v-for="(entrepreneurship) in entrepreneurshipsFiltered" :key="entrepreneurship.id">
      <v-lazy
        :options="{
          threshold: .5
        }"
        min-height="200"
        transition="fade-transition"
      >
        <cardProjectGallery 
          :data="entrepreneurship" 
          :color_category="color_tab" 
          :project_gallery_mode="project_gallery_mode" />
      </v-lazy>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import cardProjectGallery from '@/components/card/cardProjectGallery'

  export default {
    name: 'ProjectGallery',
    components:{cardProjectGallery},
    data: () => ({
      loading:true,
      find:'',
      type_postulation: null,
      tabs: 0,
      entrepreneurships:[],
      project_gallery_mode: true,
      isLiked: false
    }),
    computed: {
      ...mapGetters([
        'edition'
      ]),
      
      buttonColor() {
        return this.isLiked ? "red" : "grey lighten-1";
      }, 
      type_postulationWatcher() {
        return this.type_postulation;
      },
      color_tab () {
        switch (this.tabs) {
          case 0: return this.edition.edition.edition_customization.idea_project_color
          case 1: return this.edition.edition.edition_customization.idea_project_school_color
          case 2: return this.edition.edition.edition_customization.business_model_color
          default: return '#12EE9B'
        }
      }, 

      entrepreneurshipsFiltered(){
        return this.entrepreneurships.filter((entrepreneurship) => {
          if(this.find!=null){
            return entrepreneurship.title.toLowerCase().includes(this.find.toLowerCase());
          }else{
            return this.entrepreneurships
          }
        });
      }
    },
    watch: {
      // Watcher para type_postulationWatcher
      type_postulationWatcher(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getEntrepreneurships(); // Llama a la función getEntrepreneurships cuando cambie type_postulation
        }
      }
    },
    methods:{
      async getEntrepreneurships(){
        this.loading=true
        let tp = this.type_postulation + 1
        await axios.get('participant/entrepreneurship-windows/'+this.edition.edition.id+'/'+tp).then(response =>{
          this.entrepreneurships = response.data.windows

          this.entrepreneurships.forEach(element => {
            if(element.logo){
              element.url_logo = APP_URL + element.logo
            }else{
              element.url_logo = APP_URL+'/img/neutral.jpg'
            }
          });
          this.loading = false
        }).catch(error => {
          console.log(error);
        })
      },

      createdView()
      {
        this.tabs = this.$store.state.currentTypeTab
        this.type_postulation = this.$store.state.currentTypeTab
      },

      setData(){
        this.project_gallery_mode = this.edition.edition.edition_customization.project_gallery_mode
      },

      handleTabChange(tab)
      {
        this.$store.state.currentTypeTab = tab
        this.type_postulation = tab
      },

      likeClicked() {
        this.isLiked = !this.isLiked;
      },

      showEntrepreneurships(slug){
        this.$router.push({ name: 'showBusinessModelsWindows', params: { slug: slug } })
      },

      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },
    created(){
      Promise.all([
        this.handleEdition(),
        this.setData(),
        this.createdView()
      ]).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.tab-gallery {
  border-radius: 6px!important;
  background-color: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}
</style>
